import { render, staticRenderFns } from "./fire.vue?vue&type=template&id=687f288b&scoped=true&"
import script from "./fire.vue?vue&type=script&lang=js&"
export * from "./fire.vue?vue&type=script&lang=js&"
import style0 from "./fire.vue?vue&type=style&index=0&id=687f288b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687f288b",
  null
  
)

export default component.exports